import { b2bTranslations as b2bTranslationsEn } from '@sh4res/bo-common/i18n/en/b2b';
import { b2bAdminsTranslations } from '@sh4res/bo-common/i18n/fr/b2b/admins';
import { b2bArbitrageCreateTranslations } from '@sh4res/bo-common/i18n/fr/b2b/arbitrage_create';
import { b2bCampaignsTranslations } from '@sh4res/bo-common/i18n/fr/b2b/campaigns';
import { b2bCompaniesTranslations } from '@sh4res/bo-common/i18n/fr/b2b/companies';
import { b2bContractFeeChargesTranslations } from '@sh4res/bo-common/i18n/fr/b2b/contract_fee_charges';
import { b2bContractsTranslations } from '@sh4res/bo-common/i18n/fr/b2b/contracts';
import { b2bDocumentsTranslations } from '@sh4res/bo-common/i18n/fr/b2b/documents';
import { b2bEmployeesTranslations } from '@sh4res/bo-common/i18n/fr/b2b/employees';
import { b2bFullyManagedPlanContributionsTranslations } from '@sh4res/bo-common/i18n/fr/b2b/fully_managed_plan_contributions';
import { b2bIndividualOperationsTranslations } from '@sh4res/bo-common/i18n/fr/b2b/individual_operations';
import { b2bInvestorProfileTranslations } from '@sh4res/bo-common/i18n/fr/b2b/investor_profile';
import { b2bOperationsErTranslations } from '@sh4res/bo-common/i18n/fr/b2b/operations_er';
import { b2bOrdersTranslations } from '@sh4res/bo-common/i18n/fr/b2b/orders';
import { b2bPayoutsTranslations } from '@sh4res/bo-common/i18n/fr/b2b/payouts';
import { b2bRecurringFeeChargesTranslations } from '@sh4res/bo-common/i18n/fr/b2b/recurring_fee_charges';
import { b2bRecurringInvestmentsTranslations } from '@sh4res/bo-common/i18n/fr/b2b/recurring_investments';
import { b2bSavingsFundsRequestsTranslations } from '@sh4res/bo-common/i18n/fr/b2b/savings_funds_requests';
import { b2bSepaTranslations } from '@sh4res/bo-common/i18n/fr/b2b/sepa';
import { b2bVoluntaryPaymentCreateTranslations } from '@sh4res/bo-common/i18n/fr/b2b/voluntary_payment_create';
import { b2bWithdrawalsTranslations } from '@sh4res/bo-common/i18n/fr/b2b/withdrawals';

export const b2bTranslations = {
  companies: b2bCompaniesTranslations,
  documents: b2bDocumentsTranslations,
  employees: b2bEmployeesTranslations,
  orders: b2bOrdersTranslations,
  investor_profile: b2bInvestorProfileTranslations,
  payouts: b2bPayoutsTranslations,
  contract_fee_charges: b2bContractFeeChargesTranslations,
  recurring_fee_charges: b2bRecurringFeeChargesTranslations,
  recurring_investments: b2bRecurringInvestmentsTranslations,
  savings_funds_requests: b2bSavingsFundsRequestsTranslations,
  campaigns: b2bCampaignsTranslations,
  contracts: b2bContractsTranslations,
  sepa: b2bSepaTranslations,
  fully_managed_plan_contributions: b2bFullyManagedPlanContributionsTranslations,
  admins: b2bAdminsTranslations,
  operations_er: b2bOperationsErTranslations,
  individual_operations: b2bIndividualOperationsTranslations,
  withdrawals: b2bWithdrawalsTranslations,
  voluntary_payment_create: b2bVoluntaryPaymentCreateTranslations,
  arbitrage_create: b2bArbitrageCreateTranslations,
} satisfies typeof b2bTranslationsEn;
